export enum SearchDateOption {
  SearchByVesselETAD = 1,
  SearchByJobDate = 2,
  SearchByRequestedDeliveryDate = 3,
  SearchByExecutionDate = 4
}
